__webpack_require__.p = "https://pgrad.github.io/AI_Teacher/";